import React from 'react';
import { Block } from './renderBlocks';

// Overflow tint for a container, applied only when the Overflow overlay is on.
const OVERFLOW_STYLE = {
    over: { border: '1px solid var(--danger, #d1242f)', background: 'rgba(209,36,47,0.04)' },
    tight: { border: '1px solid var(--warn, #d4a72c)', background: 'rgba(212,167,44,0.05)' },
    fit: {},
};

// One document container (cell / text box / slide / paragraph group). For the
// flat fallback the group is unlabelled and renders as a plain stack.
export default function PreviewFrame({ group, structured, sourceLang, overlays, mutations, reference, baseline, reviewMode }) {
    const { showSource, showStatus, showConfidence, showOverflow, showTerms, showPseudo } = overlays;
    const tint = showOverflow ? OVERFLOW_STYLE[group.status] || {} : {};
    const labelled = structured && group.label;

    return (
        <div style={{
            marginBottom: labelled ? 18 : 0,
            padding: labelled ? '12px 14px' : 0,
            borderRadius: 10,
            ...tint,
        }}>
            {labelled && (
                <div style={{
                    display: 'flex', alignItems: 'center', gap: 8,
                    marginBottom: 8, fontSize: 11, color: 'var(--ink-4)',
                    textTransform: 'uppercase', letterSpacing: '0.04em',
                }}>
                    <span>{group.label}</span>
                    {group.page != null && group.page !== '' && (
                        <span style={{ opacity: 0.7 }}>· {String(group.page)}</span>
                    )}
                    {showOverflow && group.status === 'over' && (
                        <span style={{ color: 'var(--danger, #d1242f)' }}>· overflow</span>
                    )}
                    {showOverflow && group.status === 'tight' && (
                        <span style={{ color: 'var(--warn, #d4a72c)' }}>· tight</span>
                    )}
                </div>
            )}
            {group.blocks.map((block) => (
                <Block
                    key={block.id}
                    block={block}
                    sourceLang={sourceLang}
                    showSource={showSource}
                    showStatus={showStatus}
                    showConfidence={showConfidence}
                    showTerms={showTerms}
                    showPseudo={showPseudo}
                    baselineTarget={baseline ? (baseline[block.sectionIndex] ?? '') : undefined}
                    override={mutations.overrides[block.sectionIndex]}
                    busy={mutations.busy === block.sectionIndex}
                    onSave={reviewMode ? mutations.saveTranslation : undefined}
                    onToggleApprove={reviewMode ? mutations.toggleApprove : undefined}
                    matchers={reference.matchers}
                    commentCount={reference.commentCounts[block.sectionIndex] || 0}
                    getThread={reference.getThread}
                />
            ))}
        </div>
    );
}
